var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._b({directives:[{name:"autolink",rawName:"v-autolink",value:(true),expression:"true"}],tag:"component",staticClass:"button-circle",class:[
    _vm.sizeClass,
    ( _obj = {}, _obj[("-" + _vm.variant)] = _vm.variant, _obj ),
    { '-outline' : _vm.outline },
    { '-disabled' : _vm.disabled } ],attrs:{"href":_vm.to,"disabled":_vm.disabled ? _vm.disabled : null,"aria-label":_vm.text,"title":_vm.text},on:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.buttonProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }